"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const error_1 = require("../error");
class TwingErrorRuntime extends error_1.TwingError {
    constructor(message, lineno = -1, source = null, previous) {
        super(message, lineno, source, previous);
        this.name = 'TwingErrorRuntime';
    }
}
exports.TwingErrorRuntime = TwingErrorRuntime;
